cleverapps.PageSession = {
    checkStorageAvailable: function () {
        if (this.storageAvailable !== undefined) {
            return this.storageAvailable;
        }

        try {
            const date = Date.now();
            window.sessionStorage.setItem("pageSessionTest", JSON.stringify({ date }));

            const item = JSON.parse(window.sessionStorage.getItem("pageSessionTest"));

            if (item.date !== date) {
                throw Error("test not passed");
            }

            window.sessionStorage.removeItem("pageSessionTest");

            this.storageAvailable = true;
        } catch (e) {
            this.storageAvailable = false;
        }

        return this.storageAvailable;
    },

    get: function (key) {
        if (!this.checkStorageAvailable()) {
            return undefined;
        }

        try {
            return JSON.parse(window.sessionStorage.getItem(key));
        } catch (e) {
            return undefined;
        }
    },

    set: function (key, value) {
        if (!this.checkStorageAvailable()) {
            return false;
        }

        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
            return true;
        } catch (e) {
            return false;
        }
    },

    remove: function (key) {
        if (!this.checkStorageAvailable()) {
            return;
        }

        try {
            window.sessionStorage.removeItem(key);
        } catch (e) {
            // storage unavailable: nothing to clear
        }
    }
};
